import * as yup from "yup";

export const profileDirectDepositSchema = yup.object().shape({
    changeType: yup.string().required("Please choose a type of change"),
});
